import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { isEqual } from 'lodash'
import { ItemData } from '../apis/item.api'
import downloadService from '../services/download.service'
import locationApi, {
  LocationExportBinItemPalletsRequest, LocationListBinItemPalletsRequest
} from '../apis/location.api'
import { PalletData } from '../apis/pallet.api'
import Card from '../components/Card'
import List from '../components/List'
import PageHeading from '../components/PageHeading'
import TableHorizontal, {
  TableHorizontalHeader
} from '../components/TableHorizontal'
import CardButton from '../components/CardButton'

interface LocationSearchItemProps {
  item: ItemData
  locationId: number
  bin: string
}

interface LocationSearchItemState {
  pallets: PalletData[]
}

export default class LocationSearchItem
  extends Component<LocationSearchItemProps, LocationSearchItemState> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Work order"), path: 'inventory.inventoriable.code' },
    { heading: i18n("Pallet code"), path: 'code' }
  ]

  constructor (props: LocationSearchItemProps) {
    super(props)
    this.state = {
      pallets: []
    }
    this.handleExportClick = this.handleExportClick.bind(this)
  }

  get listData () {
    const { item } = this.props
    return [
      { key: 'Code', value: item.code },
      { key: 'Description', value: item.description }
    ]
  }

  listBinItemPallets () {
    const params: LocationListBinItemPalletsRequest = {
      id: this.props.locationId,
      bin: this.props.bin,
      itemId: this.props.item.id
    }
    locationApi.listBinItemPallets(params, pallets => {
      if (!pallets) return
      this.setState({ pallets })
    })
  }

  handleExportClick () {
    const params: LocationExportBinItemPalletsRequest = {
      id: this.props.locationId,
      bin: this.props.bin,
      itemId: this.props.item.id
    }
    locationApi.exportBinItemPallets(params, pallets => {
      if (!pallets) return
      downloadService.download(pallets, 'pallets.csv')
    })
  }

  componentDidMount () {
    this.listBinItemPallets()
  }

  componentDidUpdate (
    prevProps: LocationSearchItemProps,
    prevState: LocationSearchItemState
  ) {
    const { item, bin } = this.props
    const { item: prevItem, bin: prevBin } = prevProps
    const hasItemChanged = !isEqual(item, prevItem)
    const hasBinChanged = bin !== prevBin
    if (hasItemChanged || hasBinChanged) {
      this.listBinItemPallets()
    }
  }

  render () {
    return (
      <Card>
        <div className="mb-4">
          <PageHeading text={i18n("Item")} />
          <List items={this.listData} />
        </div>
        <PageHeading text={i18n("Details")} />
        <TableHorizontal
          headers={this.tableHeaders}
          data={this.state.pallets} />
        <CardButton
          proceedText={i18n("Export")}
          onProceedClick={this.handleExportClick} />
      </Card>
    )
  }
}
